{
  "menu_title": "Our Menu",
  "product_details": "Product details",
  "example_photo_label": "Example photo",
  "example_photo_notice": "Example photo. Your product will vary depending on your choices.",
  "menu_subtitle": "Choose a category, customise your order and confirm when everything is ready.",
  "welcome_title": "Welcome to Bamidi!",
  "welcome_question": "What should we call you?",
  "welcome_placeholder": "Your name…",
  "welcome_start": "Start",
  "app_title": "Bamidi Beach Bar",
  "status_waiting": "Awaiting confirmation",
  "status_confirmed": "Confirmed",
  "status_cancelled": "Cancelled",
  "welcome_customer": "Hello, {{name}}!",
  "table": "Table",
  "customise": "Customise",
  "filter_all": "All",
  "search_placeholder": "Search...",
  "cart_items": "Items",
  "items_count_one": "{{count}} item",
  "items_count_other": "{{count}} items",
  "options_count_one": "{{count}} option",
  "options_count_other": "{{count}} options",
  "view_order": "VIEW ORDER",
  "view_cart": "View cart",
  "loading": "Loading menu...",
  "add_to_cart": "Add",
  "open_cart": "Open cart",
  "cart_accessible_one": "Open cart, {{count}} item, total {{total}}",
  "cart_accessible_other": "Open cart, {{count}} items, total {{total}}",
  "added_to_cart": "{{product}} added to the cart.",
  "price": "Price",
  "ingredients": "Ingredients",
  "loading_sweetness": "Loading sweetness...",
  "filter_vegan": "Vegan",
  "filter_vegetarian": "Vegetarian",
  "filter_gluten_free": "Gluten Free",
  "checkout_title": "Finalize Order",
  "empty_cart": "Your cart is empty",
  "suggestions_title": "Goes well with...?",
  "total": "Total",
  "send_to_kitchen": "Finalize Order",
  "order_received": "Order Received!",
  "order_sent_message": "We have received order #{{id}} for Table {{table}}. You can track its status below.",
  "track_order": "Track Order",
  "active_orders_one": "{{count}} active order",
  "active_orders_other": "{{count}} active orders",
  "active_orders_title": "Active orders",
  "your_orders": "Your orders",
  "back_to_menu": "Back to Menu",
  "status_pending": "Pending",
  "status_preparing": "Preparing",
  "status_ready": "Ready",
  "msg_pending": "Awaiting confirmation…",
  "msg_preparing": "Chefs are preparing your delights!",
  "msg_ready": "All set! It's coming to your table.",
  "back": "Back",
  "order_number": "Order #{{id}}",
  "refresh": "Refresh",
  "label_track": "Track",
  "my_active_orders": "My Active Orders",
  "my_order_history": "Order History",
  "no_active_orders": "No active orders.",
  "no_history_orders": "No past orders.",
  "view_history": "View History",
  "view_active": "View Active",
  "close": "Close",
  "my_orders_count": "My Orders ({{count}})",
  "error_pending_order": "You already have pending orders. Please wait for confirmation before placing another order.",
  "order_error": "We could not send your order. Please try again.",
  "error_scan_qr": "Please scan the table QR code again to place your order.",
  "table_session_expired": "Your table session expired after 30 minutes of inactivity. Please scan the table QR code again. Your cart has been saved.",
  "menu_load_error": "We could not load the menu.",
  "retry": "Try again",
  "categories": "Categories",
  "options": "options",
  "menu_navigation": "Menu navigation",
  "featured_section": "Most ordered",
  "featured": "Popular",
  "no_filter_results": "No products match these filters",
  "no_filter_results_hint": "Try removing a filter or choosing another category.",
  "clear_filters": "Clear filters",
  "allergens": "Allergens",
  "modifier_choose_one": "Choose 1",
  "modifier_choose_min": "Choose at least {{count}}",
  "modifier_choose_up_to": "Up to {{count}}",
  "modifier_optional": "Optional",
  "modifier_category_toppings": "Toppings and extras",
  "modifier_category_fruit": "Fruit",
  "fruit_bundle_price": "Up to 3 fruits: {{first}} · 4 or more: {{more}}",
  "modifier_category_decoration": "Decorations",
  "modifier_category_ice_cream": "Ice cream flavours",
  "modifier_category_drink_flavour": "Flavour",
  "ice_cream_scoops": "Ice cream scoops",
  "extra_scoops": "Extra scoops",
  "no_extra_scoops": "No extra scoops",
  "included_scoops_one": "{{count}} scoop included",
  "included_scoops_other": "{{count}} scoops included",
  "choose_each_flavour": "Flavour for each scoop",
  "scoop_count_one": "{{count}} scoop",
  "scoop_count_other": "{{count}} scoops",
  "scoop_flavour": "Scoop {{count}}",
  "choose_flavour": "Choose a flavour",
  "choose_flavour_for_each_scoop": "Choose a flavour for each scoop.",
  "modifier_category_sauces": "Sauces",
  "quantity": "Quantity",
  "decrease_quantity": "Decrease quantity",
  "increase_quantity": "Increase quantity",
  "modifier_required_missing": "Required choices missing:",
  "order_note_label": "Anything we should know?",
  "order_note_placeholder": "e.g. no sugar, nut allergy…",
  "kitchen_closed": "Kitchen closed",
  "cafe_closed": "Cafe closed",
  "hot_drinks_photo_notice": "Hot drink photos are generic and for illustrative purposes only.",
  "recommendations_section": "Our recommendations",
  "payment_method": "Payment method",
  "payment_choose_hint": "Choose the available option to confirm your order.",
  "payment_select": "Choose this method",
  "payment_app": "Pay in the app",
  "payment_unavailable": "Temporarily unavailable",
  "payment_app_unavailable_hint": "Sorry, this option is temporarily unavailable.",
  "recommendations_short": "Recommended",
  "categories_all": "View all categories",
  "payment_title": "How would you like to pay?",
  "sending_order": "Sending…",
  "order_send_error": "We could not confirm your order. Try again; the same order will not be duplicated.",
  "payment_counter": "Pay when your products are delivered",
  "payment_counter_hint": "Cash or card.",
  "sold_out": "Sold out",
  "language": "Language",
  "allergen_aipo": "Celery",
  "allergen_amendoins": "Peanuts",
  "allergen_gluten": "Cereals containing gluten",
  "allergen_crustaceos": "Crustaceans",
  "allergen_sulfitos": "Sulphur dioxide and sulphites",
  "allergen_frutos-casca-rija": "Tree nuts",
  "allergen_leite": "Milk",
  "allergen_moluscos": "Molluscs",
  "allergen_mostarda": "Mustard",
  "allergen_ovos": "Eggs",
  "allergen_peixes": "Fish",
  "allergen_sesamo": "Sesame seeds",
  "allergen_soja": "Soybeans",
  "allergen_tremoco": "Lupin",
  "choice_decoration": "Decoration",
  "choice_fruit": "Fruit",
  "choice_toppings": "Toppings",
  "choice_sauces": "Sauces",
  "choice_drink_flavour": "Drink flavour",
  "choice_extras": "Extras",
  "choice_ice_cream_flavour": "Ice cream flavour",
  "choice_ice_cream_flavours": "Ice cream flavours",
  "staff_bell_hint": "Need a hand? Tap the bell to call a member of staff.",
  "staff_bell_hint_close": "Dismiss bell hint",
  "staff_help": "Table assistance",
  "call_staff": "Call a staff member",
  "staff_call_checking": "Checking request…",
  "staff_call_sending": "Calling…",
  "staff_call_pending": "Staff member called",
  "staff_call_offline": "Connect to call staff",
  "staff_call_sent": "A staff member has been called to table {{table}}. Please wait a moment.",
  "staff_call_resolved": "Your request has been attended to. You can call again if you need help.",
  "staff_call_error": "We could not confirm your request. Check your connection and try again.",
  "staff_call_table": "Table {{table}}",
  "add_to_order": "Add to order",
  "choose_required_options": "Choose options",
  "tracking_loading": "Loading order status…",
  "tracking_error": "Unable to update the order status. Please try again.",
  "status_delivered": "Delivered",
  "brand_description": "Ice cream & crêpes",
  "skip_to_menu": "Skip to menu",
  "menu_load_error_hint": "Check your connection and try loading the menu again."
}
